// Import model
import { StartLeadAddAppointmentRequest } from '../models/StartLeadAddAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAddAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAddAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAddAppointmentRequest instance
   */
  static deserialize(json: string): StartLeadAddAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAddAppointmentRequest instance
   */
  static fromObject(obj: any): StartLeadAddAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAddAppointmentRequest');
    }


    const instance: StartLeadAddAppointmentRequest = {
      start: obj['Start'] as string | undefined,
      duration: obj['Duration'] as string | undefined,
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      content: obj['Content'] as string | undefined,
      userId: obj['UserId'] as string | undefined,
      projectId: obj['ProjectId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAddAppointmentRequest instances
   */
  static deserializeArray(json: string): StartLeadAddAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAddAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAddAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAddAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartLeadAddAppointmentRequest): any {
    return {
      'Start': instance.start,
      'Duration': instance.duration,
      'Name': instance.name,
      'Description': instance.description,
      'Content': instance.content,
      'UserId': instance.userId,
      'ProjectId': instance.projectId,
    };
  }

  /**
   * Serializes an array of StartLeadAddAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAddAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
